import { render, staticRenderFns } from "./material-detail-header.vue?vue&type=template&id=317ef1cd&scoped=true&"
import script from "./material-detail-header.vue?vue&type=script&lang=js&"
export * from "./material-detail-header.vue?vue&type=script&lang=js&"
import style0 from "./material-detail-header.vue?vue&type=style&index=0&id=317ef1cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317ef1cd",
  null
  
)

export default component.exports